export default __webpack_public_path__ + "static/media/new-Admission.0b967986.jpg";